import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDataService } from './services/user-data.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router);
  const userData = inject(UserDataService);

  await userData.waitForAuthReady();

  if (userData.currentUser) {
    return true;
  }

  return router.createUrlTree(['/user'], {
    queryParams: {
      redirectTo: state.url
    }
  });
};
